import React from "react";
import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle, IconButton,
    makeStyles,
    Typography
} from "@material-ui/core";
import CloseIcon from '@material-ui/icons/Close';
import Controls from '../../components/controls/Controls'

const useStyle = makeStyles((theme) => ({
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
}))
export default function CommentDialog(props) {
    const {open, handleClose, handleSave, recordNumber, comment, handleCommentInputChange} = props;
const classes = useStyle();

    const handleCommentDialogSave = () => {
        handleSave(recordNumber, comment);
    }

    return (
        <Dialog open={open} onClose={handleClose}
                maxWidth='sm'
                fullWidth={true}
                aria-labelledby="form-dialog-title">
            <DialogTitle disableTypography>
                <Typography variant='h6' color='textSecondary' >
                    Write any comment
                </Typography>
                <IconButton aria-label="close"  className={classes.closeButton}  onClick={handleClose}>
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent>

                <Controls.Input
                    autoFocus
                    name='comment'
                    value={comment}
                    onChange={handleCommentInputChange}
                    margin="dense"
                    label="Comment"
                    placeholder="Enter comment if any.."
                    fullWidth
                    rows={5}
                    multiline
                    variant='outlined'
                    rowsMax={Infinity}
                    inputProps={{maxLength: 255}}
                />
            </DialogContent>
            <DialogActions>
                <Controls.Button text="Save" onClick={handleCommentDialogSave}/>
            </DialogActions>
        </Dialog>
    );
}
